import React from 'react';

const Web = () => {
    return (
        <div>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <ul>
                            <li className='title1'><h3 className='text-white '>ReactJS</h3></li>
                            
                            <li className='title1'><h3 className='text-white '>EXpressJS</h3></li>
                            <li className='title1'><h3 className='text-white '>NodeJS</h3></li>
                            </ul>
                    </div>
                    <div className="col-md-6">
                        <ul>
                            <li className='title1'><h3 className='text-white '>Javascript</h3></li>
                            <li className='title1'><h3 className='text-white '>TypeScript</h3></li>
                            <li className='title1'><h3 className='text-white '>MongoDB</h3></li>
                        </ul>
                    </div>
                </div>
            </div>
            
        </div>
    );
};

export default Web;